import { render, staticRenderFns } from "./df-page-account-expenses.vue?vue&type=template&id=4055fb3e"
import script from "./df-page-account-expenses.ts?vue&type=script&lang=js&external"
export * from "./df-page-account-expenses.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports